import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FlexEdViewComponent } from '@app/flex-ed/components/flex-ed-view/flex-ed-view.component';
import { PersonalInsightsComponent } from '@app/insights/personal-insights/personal-insights.component';
import { PersonalSkillsCareerInsightsComponent } from '@app/insights/personal-skills-career-insights/personal-skills-career-insights.component';
import { ProfileCollectionComponent } from './components/profile-collection/profile-collection.component';
import { ProfileNotFoundComponent } from './components/profile-not-found/profile-not-found.component';
import { ProfileOverviewComponent } from './components/profile-overview/profile-overview.component';
import { ProfileSkillSignalPage } from './components/profile-skill-signal-page/profile-skill-signal-page.component';
import { ProfileSkillsComponent } from './components/profile-skills/profile-skills.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ProfileBaseGuard } from './guards/profile-base.guard';
import { ProfileFlexEdGuard } from './guards/profile-flex-ed-guard';
import { ProfileOverviewGuard } from './guards/profile-overview.guard';
import { ProfileSkillCareerGuard } from './guards/profile-skill-career.guard';
import { ProfileSettings } from '@app/profile-settings/components/profile-settings.component';
import { ProfileSettingsGuard } from '@app/profile/guards/profile-settings.guard';
import { ProfileSettingsLoginGuardGuard } from '@app/profile/guards/profile-settings-login.guard';
import { ProfileSettingsLogin } from '@app/profile-settings/components/profile-settings-login/profile-settings-login.component';
import { ProfileOverviewComponent as ProfileOverviewComponentV2 } from '@app/profile/components/profile-overview-v2/profile-overview.component';
import { ProfileOverviewGuardV2 } from '@app/profile/guards/profile-overview-v2.guard';

const routes: Routes = [
  {
    path: ':id/skillstandards',
    loadChildren: () =>
      import('../skill-standards/skill-standards-profile-ratings.module').then(
        (m) => {
          return m.SkillStandardsProfileRatingsModule;
        }
      ),
  },
  {
    path: ':id',
    component: ProfileComponent,
    data: { title: 'Profile' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'overview',
      },

      {
        path: 'collection',
        component: ProfileCollectionComponent,
        canActivate: [ProfileBaseGuard],
        canLoad: [ProfileBaseGuard],
        data: { i18nTitle: 'UserController_Collection', ownerRequired: false },
      },
      {
        path: 'flex-ed',
        component: FlexEdViewComponent,
        canActivate: [ProfileFlexEdGuard],
        canLoad: [ProfileFlexEdGuard],
        data: { i18nTitle: 'dgUserOverview_FlexEd', ownerRequired: true },
      },
      {
        path: 'insights',
        component: PersonalInsightsComponent,
        canActivate: [ProfileBaseGuard],
        canLoad: [ProfileBaseGuard],
        data: { i18nTitle: 'Core_Activity', ownerRequired: false },
      },
      {
        path: 'insights/skillcareer',
        component: PersonalSkillsCareerInsightsComponent,
        canActivate: [ProfileSkillCareerGuard],
        canLoad: [ProfileSkillCareerGuard],
        data: { i18nTitle: 'Core_Insights', ownerRequired: true },
      },
      {
        path: 'overview',
        component: ProfileOverviewComponent,
        canActivate: [ProfileOverviewGuard],
        canLoad: [ProfileOverviewGuard],
        data: { i18nTitle: 'UserController_Profile', ownerRequired: false },
      },
      {
        path: 'overview-v2',
        component: ProfileOverviewComponentV2,
        canActivate: [ProfileOverviewGuardV2],
        canLoad: [ProfileOverviewGuardV2],
        data: { i18nTitle: 'UserController_Profile', ownerRequired: false },
      },
      {
        path: 'settings',
        component: ProfileSettings,
        data: { title: 'Settings', ownerRequired: true },
        canActivate: [ProfileSettingsGuard],
        canLoad: [ProfileSettingsGuard],
        loadChildren: () =>
          import('../profile-settings/profile-settings.module').then(
            (m) => m.ProfileSettingsModule
          ),
      },
      {
        path: 'settings-login',
        component: ProfileSettingsLogin,
        canActivate: [ProfileSettingsLoginGuardGuard],
        canLoad: [ProfileSettingsLoginGuardGuard],
        data: { i18nTitle: 'InputsController_Login', ownerRequired: false },
      },
      {
        path: 'signals',
        component: ProfileSkillSignalPage,
        canActivate: [ProfileOverviewGuard],
        canLoad: [ProfileOverviewGuard],
        data: {
          i18nTitle: 'dgProfileOverview_TooltipSignalsPlural',
          ownerRequired: false,
        },
      },
      {
        path: 'skills',
        component: ProfileSkillsComponent,
        data: { i18nTitle: 'Core_Skills', ownerRequired: false },
      },
      {
        path: '**',
        component: ProfileNotFoundComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProfileRoutingModule {}
